import {
	DATATYPE_GROUP,
	DATATYPE_LIST,
	DATATYPE_STRING,
	DATATYPE_ENUM,
	DATATYPE_REFERENCE
} from './instance';

import { findByKey } from '../tools'; 

export class Realm {
	
	listEnumeration = [];
	listEntityFEModel = [];	
	
	constructor(realmJson) {
		this.listClass = realmJson.listClass;
		this.listForm = realmJson.listForm;
		this.listAction = realmJson.listAction;
		this.listAccess = realmJson.listAccess;
		this.listEnumeration = realmJson.listEnumeration;
		this.listEntityFEModel = realmJson.listEntityFEModel;
	}	

	getInstanceModel(classId) {
		return findByKey(this.listEntityFEModel, 'entityId', classId);
	}

	getEnumeration(enumerationId) {
		return findByKey(this.listEnumeration, 'enumerationId', enumerationId);
	}
	getEnumerationItemText = (enumeration, itemId) => {
		if( ! enumeration )
			return '';
		if( itemId == '' )
			return '';
		var item = findByKey(enumeration.items, 'value', itemId);
		if( ! item )
			return '';
		return item.label;
	}

}
